var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("accordion", {
    attrs: { id: _vm.accordionId, group: _vm.accordionGroup },
    scopedSlots: _vm._u([
      {
        key: "trigger",
        fn: function() {
          return [
            _c("span", {
              staticClass: "icon-creator sw--margin-right-3 sw--font-size-20"
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Let us fix it")])
          ]
        },
        proxy: true
      },
      {
        key: "target",
        fn: function() {
          return [
            _c(
              "div",
              {
                staticClass:
                  "sw--margin-bottom-7 sw--margin-left-7 sw--margin-left-0--tab"
              },
              [
                _c(
                  "div",
                  { staticClass: "sw--margin-bottom-2 sw-dms--color-grey-46" },
                  [
                    _vm._v(
                      "\n        Our in-house team of designers can repair and update your model to address issues seen in the rejection image(s) provided.\n        Please note that order arrival date will change depending on the current capacity of the design team.\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "sw-dms-button sw-dms-button--big",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.displayModal(_vm.modalText)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "sw-dms--color-grey-46" }, [
                      _vm._v("Let Shapeways fix your model")
                    ])
                  ]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }